import type { User } from "./user";

export interface TruckGroup {
  _id: string;
  name: string;
  companyId: string;
  truckIds: string[]; // Array of truck IDs
  userId: string;
  user: User;
  editorUserIds: string[]; // Array of editor user IDs
  editorUsers: User[]; // Array of editor users
}

export interface TruckGroupSearchFilters {
  name?: string;
  companyId?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

// Mapper functions
export const mapTruckGroupResponse = (response: any): TruckGroup => {
  return {
    _id: response._id,
    name: response.name,
    companyId: response.companyId,
    truckIds: response.truckIds || [],
    userId: response.userId,
    user: response.user,
    editorUserIds: response.editorUserIds || [],
    editorUsers: response.editorUsers || [],
  };
};

export const mapTruckGroupsResponse = (response: any): TruckGroup[] => {
  if (!response.data || !Array.isArray(response.data?.truckGroups)) {
    return [];
  }
  return response.data.truckGroups.map(mapTruckGroupResponse);
};
